module.exports = __webpack_public_path__ + "static/media/logo-igarapemeio.053af8c0.png";